const type = 'SET_CUSTOMER_ONBOARD_OTP';

const setCustomerOnboardOtpData = (data = {}) => ({
  data,
  type,
});

export { type };
export default setCustomerOnboardOtpData;
